import Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

export function get_os_name() {
  return browser.getOSName(true);
}
